import {
  Box,
  CircularProgress,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { showDate2 } from 'src/constants';

const SecondaryTable = ({ data, columns, loading }) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: ' #414141',
      color: theme.palette.common.white,
      fontSize: 18,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  return (
    <Box sx={{ my: 2, display: 'flex', flexDirection: 'column' }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: '600px' }} aria-label="simple table">
          <TableHead>
            <StyledTableRow>
              {columns.map((col, index) => (
                <StyledTableCell key={index} align="center">
                  {t(`dashboard.${col}`)}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody sx={{ overflow: 'auto' }}>
            {data?.rowCount !== 0 &&
              !loading &&
              data?.rows.map((row, index) => (
                <StyledTableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <StyledTableCell align="center" component="th" scope="row" sx={{ fontSize: '2rem' }}>
                    {row[columns[0]] || '-'}
                  </StyledTableCell>
                  <StyledTableCell align="center" component="th" scope="row" sx={{ fontSize: '2rem' }}>
                    {row[columns[1]] || '-'}
                  </StyledTableCell>
                  <StyledTableCell align="center" component="th" scope="row" sx={{ fontSize: '2rem' }}>
                    {showDate2(row[columns[2]]) || '-'}
                  </StyledTableCell>
                  <StyledTableCell align="center" component="th" scope="row" sx={{ fontSize: '2rem' }}>
                    {showDate2(row[columns[3]]) || '-'}
                  </StyledTableCell>
                  {columns[4] && (
                    <StyledTableCell align="center" component="th" scope="row" sx={{ fontSize: '2rem' }}>
                      {t(`labels.${row[columns[4]]}`) || '-'}
                    </StyledTableCell>
                  )}
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        {loading || data?.rowCount === 0 ? (
          <Box
            sx={{
              height: '40vh',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {loading ? (
              <CircularProgress />
            ) : (
              <Typography variant="h5" color="textSecondary">
                {t('dashboard.noRecords')}
              </Typography>
            )}
          </Box>
        ) : null}
      </TableContainer>
    </Box>
  );
};

export default SecondaryTable;
